// @todo проверить, нужен ли этот eslint-disable
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";

import styles from "./DoctorSpecialitySelector.style";
import {
  Panel,
  PanelHeader,
  PanelHeaderBack,
  SimpleCell,
} from "@vkontakte/vkui";
import { connect } from "react-redux";
import { setPreviousPanel } from "../../redux/actions/panelsActions";
import Icon24Done from "@vkontakte/icons/dist/24/done";
import {
  selectDoctorName,
  selectDoctorSpeciality,
  startDoctorNamesLoading,
} from "../../redux/actions/doctorsActions";

const DoctorSpecialitySelector = ({
  id,
  goBack,
  selectDoctorSpeciality,
  startDoctorNamesLoading,
  clearSelectedName,
  sessionId,
  orderId,
  regionCode,
  doctorsSpecialities,
  error,
  selectedDoctorSpeciality,
}) => {
  const mapSpecialityToSimpleCell = (doctorSpeciality) => {
    return (
      <SimpleCell
        key={doctorSpeciality.attributes[0].value}
        onClick={() => {
          selectDoctorSpeciality(doctorSpeciality);
          goBack();
          clearSelectedName();
        }}
        after={
          selectedDoctorSpeciality &&
          areDoctorsSpecialitiesEqual(
            selectedDoctorSpeciality,
            doctorSpeciality
          ) ? (
            <Icon24Done fill="var(--accent)" />
          ) : null
        }
      >
        {doctorSpeciality.attributes[1].value}
      </SimpleCell>
    );
  };

  const areDoctorsSpecialitiesEqual = (first, second) => {
    return first.attributes[1].value === second.attributes[1].value;
  };

  useEffect(() => {
    if (selectedDoctorSpeciality) {
      startDoctorNamesLoading(
        selectedDoctorSpeciality.attributes[0].value,
        sessionId,
        orderId,
        regionCode
      );
    }
  }, [selectedDoctorSpeciality]);
  return (
    <Panel id={id}>
      <PanelHeader left={<PanelHeaderBack onClick={() => goBack()} />}>
        <span style={styles.blue}>ГОС</span>
        <span style={styles.red}>УСЛУГИ</span>
      </PanelHeader>
      {doctorsSpecialities
        ? doctorsSpecialities.map(mapSpecialityToSimpleCell)
        : null}
    </Panel>
  );
};

const mapStateToProps = (state) => {
  return {
    doctorsSpecialities: state.doctors.doctorsSpecialities,
    error: state.doctors.error,
    selectedDoctorSpeciality: state.doctors.selectedDoctorSpeciality,
    sessionId: state.userInfo.userInfo.sessionId,
    orderId: state.regionAndMedicalOrganisation.orderId,
    regionCode: state.regionAndMedicalOrganisation.selectedRegion.regionCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goBack: () => dispatch(setPreviousPanel()),
    selectDoctorSpeciality: (doctorSpeciality) =>
      dispatch(selectDoctorSpeciality(doctorSpeciality)),
    startDoctorNamesLoading: (...args) =>
      dispatch(startDoctorNamesLoading(...args)),
    clearSelectedName: () => dispatch(selectDoctorName(null)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DoctorSpecialitySelector);
